import { resendVerificationEmail } from '@/services/api/auth';
import { ResendVerificationEmailResponse } from '@/types/api/auth';
import { ApiErrorResponse } from '@/types/api/common';
import { useMutation } from '@tanstack/react-query';

export const useResendVerificationEmail = () => {
  return useMutation<ResendVerificationEmailResponse, ApiErrorResponse, string>(
    {
      mutationFn: (payload) => resendVerificationEmail(payload),
    }
  );
};
